import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-gray-800 text-white py-12" data-id="element-39">
      <div className="container mx-auto px-4" data-id="element-40">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8" data-id="element-41">
          <div className="mb-6 md:mb-0" data-id="element-42">
            <Link to="/" className="flex items-center" data-id="element-43">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/f2UgD7kEqsfMtg3Suwb9Ta/Logo_-_Eedi_-_Word_mark_-_White.png" alt="Eedi Logo" className="h-8 mr-2" data-id="element-44" />
            </Link>
            <p className="mt-3 text-gray-300 max-w-md" data-id="element-45">
              Empowering schools to shape the future of maths education
            </p>
          </div>
          <div className="text-gray-300" data-id="element-46">
            <p className="mb-2" data-id="element-47">
              Have questions? Email Harriet at{' '}
              <a href="mailto:harriet.walters@eedi.com" className="text-purple-300 hover:text-purple-200 underline transition-colors" data-id="element-48">
                harriet.walters@eedi.com
              </a>
            </p>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-6 flex flex-col md:flex-row justify-between items-center" data-id="element-49">
          <p className="text-gray-400 text-sm" data-id="element-50">
            © 2024 Eedi. All rights reserved.
          </p>
          <div className="flex space-x-4 mt-4 md:mt-0" data-id="element-51">
            <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-52">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-53">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}